/**
 * Turn a duration in seconds into hours or minutes.
 * `null`/`undefined` means the outage is still active (no matching
 * router_reachable yet) — render as "on-going" so operators can tell
 * ongoing vs resolved at a glance.
 */
export function formatDuration(seconds: number | null | undefined): string {
    if (seconds == null) {
      return "on-going";
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}m`;
    }
    if (hours > 0) {
      return `${hours}h`;
    }
    if (minutes > 0) {
      return `${minutes}m`;
    }
    return `${seconds}s`;
  }
  